import { Route, Routes } from '@angular/router';
import { routeChangeActivateGuard, routeChangeDeactivateGuard } from './guards';
import { CmsPage } from './cms/cms.page';
import { layoutResolver, storyResolver } from '@seven1/angular-storyblok-components/resolver';
import { IAppLayoutConfig } from './cms/components/layout/cms-layout';
import redirectedRoutes from '../../public/data/redirectedRoutes.json';
import { environment } from '../environments/environment';
import { maintenanceGuard } from './guards/maintenance.guard';

export const routes: Routes = [
    ...(redirectedRoutes as Route[]),
    {
        path: environment.cms.blogSlug,
        loadChildren: () => import('./blog').then((children) => children.blog_routes),
        canMatch: [maintenanceGuard],
    },
    {
        path: ':categoryId/' + environment.cms.blogSlug,
        loadComponent: () => import('./blog/category').then((page) => page.BlogCategoryPage),
        resolve: {
            story: storyResolver,
            layout: layoutResolver,
        },
        canActivate: [routeChangeActivateGuard],
        canDeactivate: [routeChangeDeactivateGuard],
        canMatch: [maintenanceGuard],
    },
    {
        path: ':categoryId/' + environment.cms.blogSlug + '/:articleId',
        loadComponent: () => import('./blog/article').then((page) => page.BlogArticlePage),
        resolve: {
            story: storyResolver,
            layout: layoutResolver,
        },
        canActivate: [routeChangeActivateGuard],
        canDeactivate: [routeChangeDeactivateGuard],
        canMatch: [maintenanceGuard],
    },
    {
        path: 'maintenance',
        component: CmsPage,
        resolve: {
            story: storyResolver,
        },
        canActivate: [routeChangeActivateGuard],
        canDeactivate: [routeChangeDeactivateGuard],
        canMatch: [maintenanceGuard],
    },
    {
        path: 'saferyou/globals/website-config',
        loadComponent: () => import('@seven1/angular/jsonld').then((m) => m.WebsiteConfigEditorPage),
        data: {
            // Storyblok deep-link to the saferyou website-config story.
            // Fill in once the space/story IDs are confirmed.
            storyblokEditUrl: '',
        },
    },
    {
        path: '**',
        component: CmsPage,
        resolve: {
            story: storyResolver,
            layout: layoutResolver<IAppLayoutConfig>,
        },
        canActivate: [routeChangeActivateGuard],
        canDeactivate: [routeChangeDeactivateGuard],
        canMatch: [maintenanceGuard],
    },
];
